import React, { useState, useEffect } from 'react';
import { useSelector } from '../../hook-utils';
import { HasClassName } from '../../component-utils';
import Button from '../Button';
import { actions } from '../../store';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import { ReactComponent as TweetMediaIcon } from '../icons/media/twitter.svg';
import './TweatView.scss';
import { formatRelativeDateTime } from '../AgentsTable';
import { selectDateFormating } from '../../store/reducers/config';
import { getTweetById } from '../../store/reducers/twitter';
import { Media } from '../../model';
import { ParkCallControlButtons } from './FacebookView';


interface Props extends HasClassName {
  tweetId: string
  queueId: string
  reply: boolean
  media?: Media
}

export default function TweatView({ className, tweetId, queueId, reply, media }: Props) {
  const tweet = useSelector(s => getTweetById(s, tweetId))
  const dispatch = useDispatch()
  const format = useSelector(selectDateFormating)
  const readOnly = media === undefined

  const [text, setText] = useState('')

  useEffect(() => {
    if (!tweet) {
      dispatch(actions.fetchTweetRequest(tweetId, queueId, reply))
    }
  }, [dispatch, tweetId, queueId, reply, tweet])

  if (!format) return null

  if (!tweet) return <div>Loading...</div>

  return <div className={classNames(className && className, 'TweatView')}>
    {media && <div className='MediaControl toolbar'>
      <ParkCallControlButtons media={media} />
    </div>}
    <div className='header'>
      <div className='icon'><TweetMediaIcon /></div>
      <div className='header-one-bold'>{tweet.receivedBy}</div>
      <div className='header-two'>Twitter Screen Name <span className='header-one-bold'>{tweet.userScreenName}</span></div>
      <div className='header-two'>Location <span className='header-one-bold'>{tweet.userLocation}</span></div>
      <div className='header-two'>Followers <span className='header-one-bold'>{tweet.userFollowersCount}</span></div>
    </div>
    <div className='border'></div>
    <div className='body'>
      <div className='profile'><img src={tweet.userProfileImageUrl} /></div>
      <div className='main'>
        <div className='grey'>@{tweet.userScreenName}</div>
        <div className='grey'>{formatRelativeDateTime(tweet.createdAtUtc, format.shortDateFormat, format.shortTimeFormat, true)}</div>
        <div className='tweet'>{tweet.subject}</div>

        {tweet.replies && tweet.replies.map((m, x) => <React.Fragment key={'chat-' + x}><div className='grey'>@ {formatRelativeDateTime(m.createdAtUtc, format.shortDateFormat, format.shortTimeFormat)}</div>
          <div className='tweet'>{tweet.receivedBy} - {m.text}</div></React.Fragment>)}
        {!readOnly && <div>
          <textarea onChange={e => {
            const c = e.currentTarget.value.length
            if (c <= 280) {
              setText(e.currentTarget.value)
            }
          }
          } value={text} />
        </div>}
        {!readOnly && <div className='status'>Character count: {text.length}</div>}
        {!readOnly && <div className='controls'>
          <Button primary className={className} onClick={() => {
            dispatch(actions.sendTweet(tweet.tweeterId, tweet.userId, text, queueId))
            setText('')
          }} disabled={text.length === 0}>Reply</Button>

        </div>}
      </div>
    </div>
  </div>
}
